import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './CookieConsent.css';

const CookieConsentBanner = () => {
  const { t, language } = useLanguage();
  const isRtl = language === 'he';

  return (
    <CookieConsent
      location="bottom"
      buttonText={
        <span>
          {t('cookieConsent.accept')} <span style={{ fontSize: '10px' }}>✕</span>
        </span>
      }
      enableDeclineButton={false}
      cookieName="hamakomSuitesCookieConsent"
      style={{
        background: "#2c3e50",
        backdropFilter: "blur(10px)",
        textAlign: isRtl ? "right" : "left",
        direction: isRtl ? "rtl" : "ltr",
        fontSize: "14px",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
        boxShadow: "0 -1px 20px rgba(0,0,0,0.3)",
        zIndex: 9999,
        border: "none",
        borderTop: "1px solid rgba(255,255,255,0.1)",
        padding: "2px 15px",
        color: "#f8f9fa",
        minHeight: "60px",
        boxSizing: "border-box"
      }}
      buttonStyle={{
        background: "#18c6af",
        color: "white",
        fontSize: "12px",
        fontWeight: "500",
        borderRadius: "15px",
        border: "none",
        padding: "6px 12px",
        margin: "0 5px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        minWidth: "70px",
        height: "32px"
      }}
      expires={365}
      onAccept={() => {
        window.dispatchEvent(new CustomEvent('cookieConsentAccepted'));
        if (window.gtag) {
          window.gtag('consent', 'update', {
            'analytics_storage': 'granted'
          });
        }
      }}
      onDecline={() => {
        if (window.gtag) {
          window.gtag('consent', 'update', {
            'analytics_storage': 'denied'
          });
        }
      }}
    >
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "space-between",
        maxWidth: "1200px", 
        margin: "0 auto",
        flexWrap: "nowrap",
        gap: "8px",
        minHeight: "32px"
      }}>
        <span style={{ 
          flex: "1", 
          minWidth: "180px",
          fontSize: "13px",
          lineHeight: "1.2"
        }}>
          {t('cookieConsent.message')}{' '}
          <Link 
            to="/Tos" 
            style={{ 
              color: "#e3e577", 
              textDecoration: "none",
              fontWeight: "500",
              borderBottom: "1px solid #e3e577"
            }}
          >
            {t('cookieConsent.moreInfo')}
          </Link>
        </span>
      </div>
    </CookieConsent>
  );
};

export default CookieConsentBanner;
